import 'css-chunksrc/client/scenes/projectResourceRemoval/styles.scss';export default {
  "warning": "_warning_1tf70_1",
  "group": "_group_1tf70_7",
  "toggle": "_toggle_1tf70_11",
  "text": "_text_1tf70_24",
  "name": "_name_1tf70_29",
  "main": "_main_1tf70_35",
  "allocationWrapper": "_allocationWrapper_1tf70_42",
  "openedInput": "_openedInput_1tf70_47",
  "input": "_input_1tf70_47",
  "quickAllocationMenu": "_quickAllocationMenu_1tf70_53",
  "toggleIcon": "_toggleIcon_1tf70_82",
  "resourceAvatar": "_resourceAvatar_1tf70_88",
  "content": "_content_1tf70_93",
  "buttons": "_buttons_1tf70_100",
  "button": "_button_1tf70_100",
  "warningTimeRecord": "_warningTimeRecord_1tf70_115",
  "listsContainer": "_listsContainer_1tf70_121",
  "noTasks": "_noTasks_1tf70_131"
};